import axios, { AxiosResponse } from "axios";
import { ResponceApi } from "../interfaces/Responses";
import { EmailModel, EmailProductoCreado, ResponseMailService } from "../interfaces/MailModel";
import { ProyectoEvntDTO } from "../interfaces/ProyectosDTOS/EventoProyDTO";
const localBack : string = process.env.REACT_APP_BACK || ''; 
const APICATALOGO : string = '/api/Email';

export default class EmailService{
  async MailNotificacion(correo:EmailModel,token:any): Promise<ResponceApi<ResponseMailService>> {        
    try {
        const response: AxiosResponse<ResponceApi<ResponseMailService>> = await axios.post(
          localBack + APICATALOGO + '/MailNotificacion',
          correo,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );            
        if (response.data) {
            //console.log(response.data)
            return response.data;
        } else {
            throw new Error('No se recibieron datos válidos.');
        }
      } catch (error) {
        console.error('Error al enviar la solicitud:', error);
        throw error; // Re-lanzar el error para que se maneje donde se llama a la función
      }
  }
    async MailProductoCreado(correo:EmailProductoCreado,token:any): Promise<ResponceApi<ResponseMailService>> {        
        try {
            const response: AxiosResponse<ResponceApi<ResponseMailService>> = await axios.post(
              localBack + APICATALOGO + '/MailProductoCreado',
              correo,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );            
            if (response.data) {
                //console.log(response.data)
                return response.data;
            } else {
                throw new Error('No se recibieron datos válidos.');
            }
          } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            throw error; // Re-lanzar el error para que se maneje donde se llama a la función
          }
      }

      async MailProductoAdjuntado(evento:ProyectoEvntDTO,token:any): Promise<ResponceApi<ResponseMailService>> {        
        try {
            const response: AxiosResponse<ResponceApi<ResponseMailService>> = await axios.post(
              localBack + APICATALOGO + '/MailProductoAdjuntado',
              evento,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );            
            if (response.data) {
                //console.log(response.data)
                return response.data;
            } else {
                throw new Error('No se recibieron datos válidos.');
            }
          } catch (error) {
            console.error('Error al enviar la solicitud:', error);
            throw error; // Re-lanzar el error para que se maneje donde se llama a la función
          }
      }
}